// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "eddbe2c2b3faf46886cfaecefa20827d" + ".js";
};